<template>
  <ul :class="classes">
    <li v-for="(item, index) in items" :key="index">
      <NuxtLink :to="item.href">{{ item.title }}</NuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import {useJsonLdStore} from "~/stores/jsonld";

type Props = {
  items: {
    title: string
    href: string
  }[]
  class?: string
  ignoreJsonLd?: boolean
}

const props = defineProps<Props>()

const classes = computed(() => ({
  'app-breadcrumbs': true,
  [`${props.class}`]: !!props.class,
}))

const jsonStore = useJsonLdStore()

if (props.ignoreJsonLd && props.items.length) {
  jsonStore.addBreadcrumbs(props.items);
}

</script>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  font-family: $font-barlow;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.33333333;
  letter-spacing: 0.08333333em;
  text-transform: uppercase;
  color: $black;
  list-style: none;

  li {
    &:not(:last-child) {
      &::after {
        content: '/';
        margin: 0 0.25rem;
      }
    }
  }
}
</style>
